import Vue from 'vue'
import i18n from '@/i18n'

const vue = new Vue({ i18n })
export default [
    /*************************************************
    * Dashboard
    *************************************************/
    {
        path: '/enquete/dashboard',
        view: 'corporativo/enquete/dashboard/Filtro',
        meta:{
            title: vue.$t("Router.Enquete.dashboard"),
        }    
    },       
    {
        path: '/enquete/dashboard/resultado/:idEnquete/:dataInicial/:dataFinal',
        view: 'corporativo/enquete/dashboard/Resultado',
        meta:{
            title: vue.$t("Router.Enquete.resultado-dashboard"),
        }    
    },        
    /*************************************************
    * Resposta
    *************************************************/
    {
        path: '/enquete/resposta/:id',
        view: 'corporativo/enquete/pergunta/Resposta',
        meta:{
            title: vue.$t("Router.Enquete.enquete"),
        }    
    }   
]
